// apps/api/src/qxcircle/qxcircle-trending.ts
// Description: QXCircle trending hashtag ranking for Explore (Slice 15).
// Owner: Masa Bayu
// Date: 2026-08-24

import type {
  QxCircleFeedPost,
  QxCircleTrendingTagRow,
  QxCircleTrendingTagsResponse,
} from "./qxcircle.types";
import { extractQxCircleTags } from "./qxcircle-hashtag";

export function buildQxCircleTrendingTags(
  posts: QxCircleFeedPost[],
  hiddenPostIds: Set<string>,
  blockedHandles: Set<string>,
): QxCircleTrendingTagsResponse {
  const buckets = new Map<string, { postCount: number; latestAt: string }>();

  for (const post of posts) {
    if (hiddenPostIds.has(post.id)) continue;
    if (blockedHandles.has(post.authorHandle)) continue;
    for (const tag of extractQxCircleTags(post.body)) {
      const current = buckets.get(tag);
      if (!current) {
        buckets.set(tag, { postCount: 1, latestAt: post.createdAt });
        continue;
      }
      current.postCount += 1;
      if (Date.parse(post.createdAt) > Date.parse(current.latestAt)) {
        current.latestAt = post.createdAt;
      }
    }
  }

  const items: QxCircleTrendingTagRow[] = [...buckets.entries()]
    .map(([tag, stats]) => ({ tag, ...stats }))
    .sort((a, b) => {
      if (b.postCount !== a.postCount) return b.postCount - a.postCount;
      return Date.parse(b.latestAt) - Date.parse(a.latestAt);
    });

  return {
    world: "qxcircle",
    slice: "explore",
    count: items.length,
    items,
  };
}
